module.exports = __webpack_public_path__ + "static/alvar-close-min-c2b70b56f28856a96b980d003e382a31.jpg";